class Navigation {

    /**
     * @since 0.2.0
     * @method constructor
     */
    constructor() {
        // Set the navigation offset
        this.offset();
    }

    /**
     * Calculate the offset for the navigation.
     *
     * @since 0.3.0
     * @method offset
     * @return void
     */
    offset() {
        // Declare and initialize
        let navigation     = $('#navigation-drawer');
        let selector       = 'label[for="navigation"]';
        let offsetSelector = '[data-navigation-offset], #wpadminbar';
        let offsets        = $(offsetSelector);
        let offsetHeight   = 0;

        // Iterate through the offsets
        offsets.each((i, ele) => offsetHeight += $(ele).height());

        // Set the height
        navigation.css('height', 'calc(100dvh - ' + offsetHeight + 'px');

        // Listen for changes
        $('body').on('click', selector, (e) => {

            // Calculate the height
            offsetHeight = 0;

            // Iterate through the offsets
            offsets.each((i, ele) => offsetHeight += $(ele).height());

            // Set it
            //navigation.css('top', offsetHeight + 'px');
            navigation.css('height', 'calc(100dvh - ' + offsetHeight + 'px');

        });
    }
}

export default Navigation;